import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

const autoNote = (message) => {
  const component = ({ event: { kind, data: { auto } } }) =>
    <div className={kind}>
      {auto && message}
    </div>;

  component.propTypes = {
    event: PropTypes.shape({
      kind: PropTypes.string.isRequired,
      data: PropTypes.shape({
        auto: PropTypes.bool,
      }).isRequired,
    }).isRequired,
    phase: PhaseType,
  };

  return component;
};

export const review_assessment = autoNote('Assessment was sent directly to store. No review required.');
export const materials_ready = autoNote('Material notification has been received from store');



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/auto_note.jsx